<template>
    <spinner />
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { FETCH_PROFILE } from '@/store/actions.type'

export default {
  name: 'MultivendeIntegrationPage',
  components: {
    Spinner
  },
  data() { return { platformSlug: 'multivende', integrationDone: false } },
  props: { type: { type: String, default: 'ongoing' } },
  computed: { ...mapGetters(['user']) },

  async beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
    await this.setMultivendeIntegration()
  },
  methods: {
    async generateApplication() {
      const { data: response } = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const platforms = response.data
      const thePlatform = platforms.find(x => x.slug === this.platformSlug)
      const application = this.$store.getters.profile.company.applications.find(x => x.platform && x.platform.id === thePlatform.id)
      if (application) return application
      const payload = {
        name: this.user.company.name + ' ' + thePlatform.name,
        company_id: this.user.company_id,
        platform_id: thePlatform.id,
        active: true
      }
      const { data } = await this.$http.post(this.$appConfig.api.baseUrl + 'applications', payload)
      return data
    },
    async setMultivendeIntegration() {
      if (!this.isValidCompany()) return false
      const credentials = await this.generateApplication()
      if (this.integrationDone) return true
      this.integrationDone = true
      const body = {
        companyId: this.user.company_id,
        userId: this.user.id,
        moovaAppId: credentials.id,
        moovaAppKey: credentials.key,
        code: String(this.$route.query.code)
      }
      const path = this.$appConfig.integrations.ecommerce.baseUrl + this.platformSlug + '/authenticate'
      const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header }
      try {
        await this.$http.post(path, body, { headers })
        this.$store.dispatch(FETCH_PROFILE).then(response => {
          const payload = { profile: this.user }
          this.$store.commit('setProfile', payload)
          this.$router.push({ name: 'company-integrations' })
        })
      } catch (error) {
        return this.throwErrorIntegration(error)
      }
    },
    isValidCompany() {
      const isValid = this.user && this.user.company_id
      if (isValid) return true
      const obj = {
        title: 'ERROR',
        message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), { helpEmail: this.helpEmail }),
        type: 'error'
      }
      this.$root.$children[0].$refs.simplert.openSimplert(obj)
      this.$router.push({ name: 'search' })
      return false
    },
    throwErrorIntegration(error) {
      if (error.status === 422) {
        const message = this.$gettext('Authorization code doesn\'t exist or is invalid for the client.<br><br>Please try again now you are identified here.')
        const obj = { title: 'ERROR', message, type: 'error' }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }

      this.$router.push({ name: 'search' })
    }
  }
}
</script>
